import { useDisclosure } from '@hooks/useDisclosure';
import { Alert, Snackbar } from '@mui/material';

type SnackbarErrorUploadImageProps = {
  errorMessage?: string;
  onClose: () => void;
};

const SnackbarErrorUploadImage: React.FC<SnackbarErrorUploadImageProps> = ({
  errorMessage,
  onClose,
}) => {
  const [openedSnackbar, { close: closeSnackbar }] = useDisclosure(true);
  const isError = errorMessage !== 'บันทึกสําเร็จ';

  return (
    <Snackbar
      open={openedSnackbar}
      autoHideDuration={2000}
      onClose={() => {
        closeSnackbar();
        onClose();
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        severity={isError ? 'error' : 'success'}
        onClose={() => {
          closeSnackbar();
          onClose();
        }}
        sx={{
          alignItems: 'center',
          marginBottom: 6,
          '.MuiAlert-icon': { py: 1 },
          '.MuiAlert-message': { py: 1 },
        }}
      >
        {errorMessage}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarErrorUploadImage;
